import { render } from "./QuestionBanksScreen.vue?vue&type=template&id=9fff6de0&scoped=true"
import script from "./QuestionBanksScreen.vue?vue&type=script&lang=js"
export * from "./QuestionBanksScreen.vue?vue&type=script&lang=js"

import "./QuestionBanksScreen.vue?vue&type=style&index=0&id=9fff6de0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fff6de0"]])

export default __exports__